import React, { useState, useEffect } from 'react';
import ImageCropper from './ImageCropper';
import { Row, Col, Button, Card, InputGroup } from 'react-bootstrap';
import Markdown from './Markdown';
//import { Form, Table, Row, Col, InputGroup, FormControl, Button, Card } from "react-bootstrap";
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { useProvider, isNative } from '../../context/MenuProvider';
import { Device } from '@capacitor/device';

// Correção para os ícones padrão do Leaflet que às vezes somem no React
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

const Localizacao = ({ localizacao, latitude, longitude, style, endereco }) => {
  const [latLng, setLatLng] = useState();
  const [plataforma, setPlataforma] = useState(null);

  useEffect(() => {
    // Primeiro, separamos os valores da string ou usamos os props individuais
    const [latStr, lngStr] = localizacao ? localizacao.split(',') : [latitude, longitude];

    // Depois convertemos para Float com fallback
    const lat = latStr ? parseFloat(latStr) : -12.0000;
    const lng = lngStr ? parseFloat(lngStr) : -60.0000;

    if (localizacao || (latitude && longitude)) {
      setLatLng({
        lat,
        lng
      });
    }

    const map = L.map('map', {
      zoomControl: false,
      dragging: false,
      scrollWheelZoom: false,
      doubleClickZoom: false,
      touchZoom: false,
      attributionControl: false
    }).setView([lat, lng], (localizacao || (latitude && longitude)) ? 17 : 3);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map);

    if (localizacao || (latitude && longitude)) {
      L.marker([lat, lng]).addTo(map);
    }
    const getInfo = async() => {
      const plat = isNative ? (await Device.getInfo()) : navigator.platform;
      setPlataforma(plat?.platform);
    }
    getInfo();

    return () => {
      map.remove();
    };
  }, [localizacao, latitude, longitude]);

  const backgroundStyle = {
    height: '200px',
    backgroundSize: "cover",
    backgroundPosition: "center",
    zIndex: 0,
    backgroundColor: '#e5e3df',
    ...style
  };

  const abrirMapa = (tipo) => {
    if (!latLng) return;

    const posicao = `${latLng.lat},${latLng.lng}`;
    let url = "";

    switch (tipo) {
      case 'google':
        url = isNative
          ? `google.navigation:q=${posicao}`
          : `https://www.google.com/maps/search/?api=1&query=${posicao}`;
        break;
      case 'waze':
        url = isNative
          ? `waze://?ll=${posicao}&navigate=yes`
          : `https://www.waze.com/ul?ll=${posicao}&navigate=yes`;
        break;
      case 'apple':
        url = isNative
          ? `maps://?q=${posicao}`
          : `https://maps.apple.com/?q=${posicao}`;
        break;
      default:
        return;
    }

    window.open(url, isNative ? '_system' : '_blank');
  };

  const abrirEndereco = () => {
    if (!endereco) return;

    const enderecoEncoded = encodeURIComponent(endereco);
    let url = "";

    if (isNative) {
      url = plataforma === 'ios'
        ? `maps://?q=${enderecoEncoded}`
        : `geo:0,0?q=${enderecoEncoded}`;
    } else {
      url = `https://www.google.com/maps/search/?api=1&query=${enderecoEncoded}`;
    }

    window.open(url, isNative ? '_system' : '_blank');
  };

  return (
    <>
      <div id="map" style={backgroundStyle}></div>
      <div style={{marginTop: "-40px", zIndex: 100, position: 'relative', ...style?.btns}}>
        <Row className="justify-content-center g-0">
          <Col xs="auto">
            <InputGroup size="sm" className="m-1">
              {(plataforma !== 'ios' && latLng) && (
                <Button
                  variant="secondary"
                  onClick={(e) => { e.stopPropagation(); abrirMapa('google'); }}
                >
                  <i className="fab fa-google"></i> Google
                </Button>
              )}

              {latLng && (<>
                <Button
                  variant="secondary"
                  onClick={(e) => { e.stopPropagation(); abrirMapa('waze'); }}
                >
                  <i className="fab fa-waze"></i> Waze
                </Button>
              </>)}

              {(plataforma !== 'android' && latLng) && (
                <Button
                  variant="secondary"
                  onClick={(e) => { e.stopPropagation(); abrirMapa('apple'); }}
                >
                  <i className="fab fa-apple"></i> Apple
                </Button>
              )}

              {endereco && (
                <Button
                  onClick={(e) => { e.stopPropagation(); abrirEndereco(); }}
                  variant="secondary"
                >
                  <i className="fas fa-search"></i> {endereco.length > 6 ? endereco.slice(0, 6) + "..." : endereco}
                </Button>
              )}
            </InputGroup>
          </Col>
        </Row>
      </div>
    </>
  );
};


const PerfilParte = ({ cliente }) => {
  const [isFull, setIsFull] = useState(false);
  const backgroundStyle = {
    height: '200px',
    marginTop: '-30px',
    //paddingTop: '200px',
    //backgroundSize: "cover",
    //backgroundPosition: "center",
    //zIndex: 0,
    //backgroundColor: '#e5e3df',
    btns:{
      marginTop: '60px',
      //height: '200px',
    }
  };
  return (
    <>
      {isFull && (
        <>
          <Localizacao style={backgroundStyle} localizacao={cliente?.posicao_mapa} endereco={cliente?.endereco}/>
          
          <div onClick={() => setIsFull(!isFull)} style={{ marginTop: "-145px", position: 'relative', zIndex: 5 }}>
            <ImageCropper
              so_exibe={true}
              radius={50}
              foto={cliente?.foto_perfil}
              width={200}
              height={200}
            />
          </div>
          <Row onClick={() => setIsFull(!isFull)}>
            <Col style={{ marginTop: "-20px", position: 'relative', zIndex: 6 }} xs="auto" className="fs-4 mb-3 bg-light pt-2 text-center mx-auto">
              {cliente?.nome || cliente?.full_name || cliente?.nome_do_cliente || ''}
            </Col>
          </Row>
        </>
      )}

      {!isFull && (
        <Row onClick={() => setIsFull(!isFull)}>
          <Col xs={3} md={1}>
              <ImageCropper
                so_exibe={true}
                radius={20}
                foto={cliente?.foto_perfil}
                width={100}
                height={100}
                xs="" 
                md=""
              />
          </Col>
          <Col className="mb-3">
            <div className="fs-4">
              {cliente?.nome || cliente?.full_name || cliente?.nome_do_cliente || ''}
            </div>
            <div className="text-muted small">
              {cliente?.endereco || ''}
            </div>
          </Col>
        </Row>
      )}

      {(cliente?.endereco && isFull) && (
        <Row onClick={() => setIsFull(!isFull)}>
          <Col style={{ marginTop: "-15px", position: 'relative', zIndex: 1 }} xs="auto" className="text-muted small mb-3 bg-light text-center mx-auto">
            {cliente?.endereco || ''}
          </Col>
        </Row>
      )}

      {cliente?.observacoes && (
        <Row>
          <Col style={{ marginTop: "-15px", position: 'relative', zIndex: 1 }} className="text-muted small mb-3 bg-light">
            <Card className="p-1">
              <Markdown texto={cliente?.observacoes}></Markdown>
            </Card>
          </Col>
        </Row>
      )}
    </>
  );
};


export {
  Localizacao
}
export default PerfilParte;